import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./blog.css";
// import { Helmet } from 'react-helmet-async';
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
import { Spin } from "antd";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchBlogs = async () => {
    try {
      const res = await axios.get(
        "https://cafemandhurah.mandurahcafe.com.au/api/blogs"
      );
      const activeBlogs = (res.data?.data || []).filter(
        (blog) => blog.is_active
      );
      setBlogs(activeBlogs.reverse()); // Reverse the order
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
    } finally {
      setLoading(false); // stop spinner
    }
  };

  fetchBlogs();
}, []);


  return (
    <>
      <SeoHelmet page="blog" />
      <BreadcrumbBanner
        title="Blogs"
        backgroundImage="/Images/banner-about.jpg"
      />

      <Spin spinning={loading} tip="Loading Blogs..." className="loading">
        <div className="blog-list-container">
          <h2 className="blog-list-title">Our Latest Blogs</h2>
          <div className="blog-grid">
            {blogs.map((blog) => (
              <Link
                to={`/informative-blog/${blog.slug}`}
                className="blog-card"
                key={blog.id}
              >
                <div className="blog-card-image">
                  <img
                    src={blog.featured_image || "/Images/blog-default.png"}
                    alt={blog.title}
                    loading="lazy"
                  />
                </div>
                <div className="blog-card-content">
                  <p className="blog-category">{blog.category}</p>
                  <h3 className="blog-title">{blog.title}</h3>
                  <p className="blog-date">
                    {new Date(blog.created_at).toLocaleDateString()}
                  </p>
                  <p className="blog-readmore">Read More →</p>
                </div>
              </Link>
            ))}
          </div>
        </div>{" "}
      </Spin>
    </>
  );
};

export default Blog;
